import { ToggleRow } from '@/components/common/ToggleRow'

interface DisplaySettingsProps {
    showAgenda: boolean
    showSpeakerBios: boolean
    showCountdown: boolean
    showDuration: boolean
    onChange: (field: 'ShowAgenda' | 'ShowSpeakerBios' | 'ShowCountdown' | 'ShowDuration', value: boolean) => void
    disabled?: boolean
}

export function DisplaySettings({ showAgenda, showSpeakerBios, showCountdown, showDuration, onChange, disabled }: DisplaySettingsProps) {
    return (
        <div className="space-y-1 divide-y divide-slate-100 dark:divide-slate-700">
            <ToggleRow label="Show Agenda" checked={showAgenda} onChange={(v) => onChange('ShowAgenda', v)} disabled={disabled} />
            <ToggleRow label="Show Speaker Bios" checked={showSpeakerBios} onChange={(v) => onChange('ShowSpeakerBios', v)} disabled={disabled} />
            <ToggleRow label="Show Countdown" checked={showCountdown} onChange={(v) => onChange('ShowCountdown', v)} disabled={disabled} />
            <ToggleRow label="Show Duration" checked={showDuration} onChange={(v) => onChange('ShowDuration', v)} disabled={disabled} />
        </div>
    )
}
